import { useTranslation } from 'react-i18next';

import { Close } from '@/package';
import { Done, VFlex, new__cn as cn, useFlag } from '@/package';

export const TrackIDPasteNotification = ({
  copiedTrackID,
  onPaste,
}: {
  copiedTrackID: string;
  onPaste: () => void;
}) => {
  const { t } = useTranslation();
  const { value: visible, setFalse: hide } = useFlag(true);

  return (
    <VFlex
      className={cn(
        'w-full rounded-sm bg-skyBlue-300 px-scale/8 py-scale/4 shadow-sm',
        !visible && 'hidden',
      )}
      gap={0.25}
      items="center"
      justify="between"
    >
      <div className="text-body-sm">
        {t('labeling.boxInspectorPasteTrackID.duplication')}
      </div>
      <VFlex gap={0.25} items="center" justify="between">
        <div className="text-body-md tracking-tight">{copiedTrackID}</div>
        <Done
          className="size-4 text-primary-500 hover:text-primary-400 active:text-primary-600"
          role="button"
          onClick={() => onPaste()}
        />
        <Close
          className="size-3 text-gray-400 hover:text-gray-300 active:text-gray-500"
          role="button"
          onClick={() => hide()}
        />
      </VFlex>
    </VFlex>
  );
};

TrackIDPasteNotification.displayName = 'TrackIDPasteNotification';
